<div class="book-content" #contentRef
     [class.hide-spoiler-image]="ebookDisplayManagerService.hideSpoilerImage$ | async"
     [class.show-spoiler-image]="!(ebookDisplayManagerService.hideSpoilerImage$ | async)"
     [class.hide-furigana]="ebookDisplayManagerService.hideFurigana$ | async"></div>
